<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="sisModulo" titulo="Permisos / Sistema" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>

                    </div>
                </section>
                <div class="is-fullwidth has-text-centered" *ngIf="!ctrl.datosCargados">
                    <br>
                    <span class="tag is-primary is-large ">
                        <span class="icon">
                            <i class="icon-worldwide fa-spin"></i>
                        </span> &nbsp;
                        <span>Cargando...</span>
                    </span>
                </div>
                <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">

                    <a id="catalogos" (click)="ctrl.cargarCatalogo('padres', 'sisModulo'); "></a>
                    <div class="columns">
                        <div class="column is-6">
                            <label class="label">Nombre: </label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }"
                                    placeholder="nombre" formControlName="nombre">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                            </p>
                        </div>
                        <div class="column is-6">
                            <label class="label">Controlador: </label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('controlador').hasError('required') && ctrl.dato.get('controlador').hasError('required')}"
                                    placeholder="controlador" formControlName="controlador">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('controlador').hasError('required') && ctrl.dato.get('controlador').hasError('required')">
                                    <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('controlador').hasError('required') && ctrl.dato.get('controlador').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column is-6">
                            <label class="label">Padre:</label>
                            <div class="select">
                                <select class="select" formControlName="sis_modulos_id">
                                    <optgroup *ngFor="let val of ctrl.padres | groupBy:'modulo_padre'" label="{{val.key}}">
                                        <option *ngFor="let item of val.value" value="{{item.id}}">{{item.nombre}}</option>
                                    </optgroup>
                                </select>
                            </div>
                        </div>
                        <div class="column is-3">
                            <br>
                            <br>
                            <div class="b-checkbox is-info">
                                <input id="vista" class="styled" [checked]="ctrl.dato.get('vista').value == '1' ? true : false" (change)="ctrl.dato.get('vista').patchValue(ctrl.dato.get('vista').value == '1' ? '0' : '1')"
                                    type="checkbox">
                                <label for="vista">
                                    Tiene vista?
                                </label>
                            </div>
                        </div>
                        <div class="column is-3" *ngIf="activar_super">
                            <br>
                            <br>
                            <div class="b-checkbox is-info">
                                <input id="es_super" class="styled" [checked]="ctrl.dato.get('es_super').value == '1' ? true : false" (change)="ctrl.dato.get('es_super').patchValue(ctrl.dato.get('es_super').value == '1' ? '0' : '1')"
                                    type="checkbox">
                                <label for="es_super">
                                    Es para super?
                                </label>
                            </div>
                        </div>
                    </div>

                    <nav class="panel">
                        <section class="hero is-light">
                            <div class="hero-head">
                                <nav class="level">
                                    <!-- Left side -->
                                    <div class="level-left">
                                        <div class="level-item">
                                            <p class="title is-4" style=" padding-left: 10px; ">
                                                <span class="icon is-medium">
                                                    <i class="icon-list "></i>
                                                </span> Metodos del controlador
                                            </p>
                                        </div>


                                    </div>

                                    <!-- Right side -->
                                    <div class="level-right">

                                        <a class="navbar-item  tooltip" (click)="ctrl.agregar_form_array(ctrl.dato.controls.metodos, form_metodos)">
                                            <span class="icon has-text-success">
                                                <i class="icon-add2"></i>
                                            </span>
                                            <span class="tooltiptext">Agregar Método</span>
                                        </a>

                                        <a class="navbar-item  tooltip" (click)="defaultMetodo(ctrl.dato.controls.metodos)">
                                            <span class="icon has-text-info">
                                                <i class="icon-file"></i>
                                            </span>
                                            <span class="tooltiptext">Métodos Default</span>
                                        </a>

                                        <a class="navbar-item  tooltip" (click)="quitarAllMetodo()">
                                            <span class="icon has-text-danger">
                                                <i class="icon-trash"></i>
                                            </span>
                                            <span class="tooltiptext">Limpiar lista</span>
                                        </a>
                                    </div>
                                </nav>
                            </div>
                        </section>
                        <div class="panel-block">
                            <div formArrayName="metodos">
                                <div *ngFor="let item of ctrl.dato.controls.metodos.controls; let i=index" class="column" style="min-width:280px; width:19.5%; float:left">
                                    <nav class="panel" [formGroupName]="i">
                                        <div class="panel-heading">
                                            <label class="label">Nombre: </label>
                                            <input class="input" type="text" placeholder="nombre" formControlName="nombre">
                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.metodos.controls[i].controls.nombre.valid">Este campo es requerido.</span>
                                            <a style="float:right; margin-top: -65px;" class="is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.metodos, i)">
                                                <span class="icon has-text-danger">
                                                    <i class="icon-trash"></i>
                                                </span>
                                            </a>
                                        </div>
                                        <label class="panel-block">
                                            <label class="label">Recurso: </label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" type="text" placeholder="recurso" formControlName="recurso">
                                                <span class="help is-danger" *ngIf="!ctrl.dato.controls.metodos.controls[i].controls.recurso.valid">Este campo es requerido.</span>
                                            </p>
                                        </label>

                                        <label class="panel-block">
                                            <label class="label">Método: </label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" name="metodo" formControlName="metodo" [ngClass]="{'is-warning': metodo?.length ==0 }">
                                                        <option value="delete">DELETE</option>
                                                        <option value="get">GET</option>
                                                        <option value="post">POST</option>
                                                        <option value="put">PUT</option>
                                                    </select>
                                                </div>
                                                <span class="help is-danger" *ngIf="!ctrl.dato.controls.metodos.controls[i].controls.metodo.valid">Este campo es requerido.</span>
                                            </div>
                                        </label>
                                        <label class="panel-block" *ngIf="activar_super">
                                            <div class="field">
                                                <div class="b-checkbox is-info">
                                                    <input id="es_super{{i}}" class="styled" type="checkbox" formControlName="es_super">
                                                    <label for="es_super{{i}}">
                                                        Es para super?
                                                    </label>
                                                </div>
                                            </div>
                                        </label>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </nav>

                </section>
            </form>
        </div>
    </div>
</div>